<template>
  <a href="#" class="underline tracking-wide cursor-pointer">
    <slot/>
  </a>
</template>

<script>
export default {
  name: 'LinkButton'
}
</script>

<style scoped>

</style>
